import React from "react";
import ReactDOM from "react-dom/client";
// import { ApiInitializerContainer } from "./ApiInitializerContainer";
import App from "./App";
// import "./index.css";
import ApiInitializerContainer from "./ApiInitializerContainer";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ApiInitializerContainer>
      <App />
    </ApiInitializerContainer>
  </React.StrictMode>
);

reportWebVitals();
